/***
 * Shamelessly ripped from NU/ultipro-web
 * https://ultigit.ultimatesoftware.com/projects/NUI/repos/ultipro-web/browse/src/app/services/localization/localization-loader.ts
 */
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of, throwError } from 'rxjs';
import translationPackage from 'i18n';

interface LanguageFallbackMap {
  [language: string]: string;
}

const { keys } = Object;

const fallbackLanguage = 'en-US';
const fallbackMap: LanguageFallbackMap = {
  en: 'en-US',
};

export class UltiTranslateLoader implements TranslateLoader {
  private readonly languages: string[];

  constructor() {
    this.languages = [...keys(translationPackage), ...keys(fallbackMap)];
  }

  getTranslation(lang: string): Observable<any> {
    if (!lang) {
      return throwError(new Error('No language passed'));
    }

    if (!this.isLanguageSupported(lang)) {
      lang = fallbackLanguage;
    }

    return of(translationPackage[lang] || translationPackage[fallbackMap[lang]]);
  }

  isLanguageSupported(lang: string): boolean {
    return this.languages.indexOf(lang) !== -1;
  }
}
